import { render, staticRenderFns } from "./legal-document.vue?vue&type=template&id=6e9c6630&scoped=true"
import script from "./legal-document.vue?vue&type=script&lang=js"
export * from "./legal-document.vue?vue&type=script&lang=js"
import style0 from "./legal-document.vue?vue&type=style&index=0&id=6e9c6630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9c6630",
  null
  
)

export default component.exports